import { Box, Divider, Stack, Typography } from "@mui/material";
import { CareForm } from "@/__generated__/schema.graphql.types";
import InfoCard from "@/components/common/infoCard/infoCard";
import { TruncatedReadOnlyQuill } from "@/components/common/quill/readOnlyQuill";
import ExpandableSection from "@/components/serviceFlow/clientDetails/expandableSection";

type Service = {
  id: string;
  name: string;
};

export type CareForms = Array<
  Pick<CareForm, "id" | "name" | "text"> & {
    services: Service[];
    appointmentServices?: Service[];
  }
>;

export default function CareFormsSection({
  title,
  forms,
}: {
  title: string;
  forms: CareForms;
}) {
  if (!forms?.length) return null;

  return (
    <InfoCard>
      <ExpandableSection title={title} expanded>
        <Stack
          divider={<Divider variant="fullWidth" sx={{ my: 2 }} />}
          sx={{ mt: 2 }}
        >
          {forms.map((form) => (
            <Box key={form.id}>
              <Typography
                variant="h3"
                sx={{
                  color: "text.dark",
                  mb: 1,
                }}
              >
                {form.appointmentServices
                  ? form.appointmentServices
                      .map((service) => service.name)
                      .join(", ")
                  : form.services.map((service) => service.name).join(", ")}
              </Typography>
              <TruncatedReadOnlyQuill value={form.text} isParagraph />
            </Box>
          ))}
        </Stack>
      </ExpandableSection>
    </InfoCard>
  );
}
